/**
 * This class will be used for identification
 * of the instances the host sends over to
 * the Apps-Engine
 */
export abstract class BaseBridge {}
